"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./RowGrid.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import { everyChildOfSpecificTag } from '@bit/gerenciatd.utils.react-utils';
var RowGrid = function RowGrid(_ref) {
  var children = _ref.children,
      visibleMobile = _ref.visibleMobile,
      hideMobile = _ref.hideMobile,
      mobileReversed = _ref.mobileReversed;

  /* const everyChildAreCols = everyChildOfSpecificTag('ColGrid', children); */

  /* if (!everyChildAreCols) {
    console.warn("Every child of RowGrid must be a ColGrid component")
  }*/
  var rowClass = 'row margin0';

  if (visibleMobile) {
    rowClass = "".concat(rowClass, " visible-xs");
  }

  if (hideMobile) {
    rowClass = "".concat(rowClass, " hide-xs");
  }

  if (mobileReversed) {
    rowClass = "".concat(rowClass, " mobileReversed");
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: rowClass,
    children: children
  });
};
/*  Proptypes for the Card props */


RowGrid.propTypes = {
  children: _propTypes["default"].node.isRequired,
  visibleMobile: _propTypes["default"].bool,
  hideMobile: _propTypes["default"].bool,
  mobileReversed: _propTypes["default"].bool
};
RowGrid.defaultProps = {
  visibleMobile: false,
  hideMobile: false,
  mobileReversed: false
};
var _default = RowGrid;
exports["default"] = _default;

//# sourceMappingURL=index.js.map